module.exports = __webpack_public_path__ + "img/imposta-logo-careers.57ecaa6f.png";